import React from 'react'
import { useDispatch } from 'react-redux'
import { HelpIcon } from '@Root/assets'
import { modalActions } from '@Root/store'
import styles from './style.module.scss'

const HANDBOOK_URL = 'https://handbook.teid.uk/'
const HANDBOOK_LOGIN = 'handbook_admin'
const HANDBOOK_PASSWORD = 'Hbk_7vN4qZ9pL2xR'

export const HandbookHelp = () => {
  const dispatch = useDispatch()

  const onOpen = () => {
    new Promise((resolve, reject) => {
      dispatch(
        modalActions.showModal('NotificationModal', {
          title: 'TEID Handbook',
          text: `
            <div style="text-align:left;word-break:normal;line-height:1.5;">
              <p style="margin:0 0 6px;font-weight:600;">Cognito field mapping handbook</p>
              <p style="margin:0 0 18px;">
                <a href="${HANDBOOK_URL}" target="_blank" rel="noopener noreferrer">${HANDBOOK_URL}</a>
              </p>
              <p style="margin:0 0 10px;font-weight:600;">Basic authentication</p>
              <table style="border-collapse:collapse;width:100%;font-size:13px;">
                <tr>
                  <td style="padding:4px 12px 4px 0;color:#6b6b6b;width:90px;vertical-align:top;">Login</td>
                  <td style="padding:4px 0;font-family:monospace;word-break:break-all;">${HANDBOOK_LOGIN}</td>
                </tr>
                <tr>
                  <td style="padding:4px 12px 4px 0;color:#6b6b6b;vertical-align:top;">Password</td>
                  <td style="padding:4px 0;font-family:monospace;word-break:break-all;">${HANDBOOK_PASSWORD}</td>
                </tr>
              </table>
            </div>
          `,
          clickRejectButtonHandler: reject,
          clickResolveButtonHandler: resolve,
        })
      )
    }).finally(() => dispatch(modalActions.hideModal()))
  }

  return (
    <button type='button' className={styles.button} onClick={onOpen} aria-label='Open TEID Handbook help' title='TEID Handbook'>
      <img src={HelpIcon} alt='' width={20} height={20} />
    </button>
  )
}
